import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from "../config.js";
import { useToast } from '../context/ToastContext.js';

function Profile({ athletes, googleFormLink }) {
  const toast = useToast();
  const { id } = useParams();
  const athleteId = Number(id);
  const athlete = athletes?.find(a => a.id === athleteId);
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem('user'))?.token;

  const [taskAssigned, setTaskAssigned] = useState(athlete?.bodyMapTaskAssigned || false);

  const assignBodyMapTask = async () => {
    setTaskAssigned(true);
    try {
      await axios.post(`${API_BASE_URL}/athletes/${athlete.id}/assign-task`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
    } catch (err) {
      console.error('Failed to assign task:', err);
      setTaskAssigned(false);
      toast.error('Failed to assign task.');
    }
  };

  const handleViewBodyMap = () => navigate(`/body-map/${athleteId}`);

  if (!athletes) return <div>Loading...</div>;
  if (!athlete) return <div>Athlete not found</div>;

  return (
    <div>
      <h2>{athlete.name}'s Profile</h2>
      <p><strong>Date of Birth:</strong> {athlete.dob}</p>
      <p><strong>Height:</strong> {athlete.height} cm</p>
      <p><strong>Weight:</strong> {athlete.weight} kg</p>
      <p><strong>Email:</strong> {athlete.email}</p>
      <p><strong>Phone Number:</strong> {athlete.phone}</p>
      <p><strong>Contact Person:</strong> {athlete.emergency_contact_name}</p>
      <p><strong>Contact Phone Number:</strong> {athlete.emergency_contact_phone}</p>

      {taskAssigned ? (
        <>
          <p>BodyMap Task Assigned</p>
          <button onClick={handleViewBodyMap}>Complete BodyMap</button>
        </>
      ) : (
        <button onClick={assignBodyMapTask}>Assign BodyMap Task</button>
      )}

      {googleFormLink && (
        <div>
          <h3>Google Form</h3>
          <a href={googleFormLink} target="_blank" rel="noopener noreferrer">
            Complete the Google Form
          </a>
        </div>
      )}
    </div>
  );
}

export default Profile;
